import { DataType, TITLES, COMPETITORS } from '../types/GridTypes';

export const calculatePrices = (
  flight: DataType,
  calculationFilter: any,
  relevantCompetitorsFlights: any,
) => {
  const myPrice = parseFloat(flight[TITLES.MY_PRICE].replace('$', ''));
  const priceComparison: any = {
    [TITLES.PRICE_VS_MARKET]: [],
    [TITLES.PRICE_VS_BRITISH_AIRWAYS]: [],
    [TITLES.PRICE_VS_BLUE_AIR]: [],
    [TITLES.PRICE_VS_WIZZ_AIR]: [],
    [TITLES.PRICE_VS_RYANAIR]: [],
    [TITLES.PRICE_VS_EASY_JET]: [],
  };
  try {
    for (const comp of relevantCompetitorsFlights) {
      if (
        !(
          flight[TITLES.FLIGHT_DUE_DATE] === comp[TITLES.FLIGHT_DUE_DATE] ||
          !calculationFilter.Date
        )
      ) {
        continue;
      }
      if (
        !(
          flight[TITLES.ARRIVAL_TYPE] === comp[TITLES.ARRIVAL_TYPE] ||
          !calculationFilter.ArrivalType
        )
      ) {
        continue;
      }
      if (
        !(
          flight[TITLES.DESTINATION_COUNTRY] ===
            comp[TITLES.DESTINATION_COUNTRY] || !calculationFilter.Destination
        )
      ) {
        continue;
      }
      if (
        !(
          flight[TITLES.DESTINATION_AIRPORT] ===
            comp[TITLES.DESTINATION_AIRPORT] || !calculationFilter.Airport
        )
      ) {
        continue;
      }
      priceComparison[TITLES.PRICE_VS_MARKET].push(comp[COMPETITORS.MY_PRICE]);
      if (comp[COMPETITORS.COMPETITOR] === 'Blue Air') {
        priceComparison[TITLES.PRICE_VS_BLUE_AIR].push(
          comp[COMPETITORS.MY_PRICE],
        );
      }
      if (comp[COMPETITORS.COMPETITOR] === 'Wizz-Air') {
        priceComparison[TITLES.PRICE_VS_WIZZ_AIR].push(
          comp[COMPETITORS.MY_PRICE],
        );
      }
      if (comp[COMPETITORS.COMPETITOR] === 'Ryanair') {
        priceComparison[TITLES.PRICE_VS_RYANAIR].push(
          comp[COMPETITORS.MY_PRICE],
        );
      }
      if (comp[COMPETITORS.COMPETITOR] === 'EasyJet') {
        priceComparison[TITLES.PRICE_VS_EASY_JET].push(
          comp[COMPETITORS.MY_PRICE],
        );
      }
      if (comp[COMPETITORS.COMPETITOR] === 'British Airways') {
        priceComparison[TITLES.PRICE_VS_BRITISH_AIRWAYS].push(
          comp[COMPETITORS.MY_PRICE],
        );
      }
    }
    for (let key in priceComparison) {
      let prices = priceComparison[key]
        .filter((price: string) => price !== null && price !== '0$')
        .map((price: string) => parseFloat(price.replace('$', '')));
      if(!prices.length) {
        continue;
      }
      let avg =
        prices.reduce((sum: number, price: number) => sum + price, 0) /
        prices.length;
      if (isNaN(avg)) {
        avg = 0;
        priceComparison[key][0] = avg;
        priceComparison[key][1] = avg;
        continue;
      }
      priceComparison[key][0] = Math.round(avg);
      priceComparison[key][1] = Math.round(((myPrice - avg) / avg) * 100);
    }
    if(priceComparison[TITLES.PRICE_VS_MARKET][0]) {
      priceComparison[TITLES.PRICE_DIFFERENCE] = Math.round(myPrice - priceComparison[TITLES.PRICE_VS_MARKET][0]);
    }
  } catch (e) {}
  return priceComparison;
};
